import WalletAdd from "./WalletAdd";

export default WalletAdd;
